import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';

// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Autoplay, Thumbs, Keyboard]);
window.Swiper = Swiper;

// Lazyload
import lazyLoadInit from '../../../../general/js/lazy';
lazyLoadInit();

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
const buildSwiperCustom = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;

    var delay = typeof sliderElm.dataset.delay !== 'undefined' ? sliderElm.dataset.delay : 2500 ;
    var slides_xs = typeof sliderElm.dataset.xs !== 'undefined' ? sliderElm.dataset.xs : 3 ;
    var slides_md = typeof sliderElm.dataset.md !== 'undefined' ? sliderElm.dataset.md : 4 ;
    var slides_lg = typeof sliderElm.dataset.lg !== 'undefined' ? sliderElm.dataset.lg : 5 ;
    var slides_xl = typeof sliderElm.dataset.xl !== 'undefined' ? sliderElm.dataset.xl : 6 ;

    var center_slides = typeof sliderElm.dataset.center_slides !== 'undefined' ? sliderElm.dataset.center_slides : false ;
    var center_slides_bounds = typeof sliderElm.dataset.center_slides_bounds !== 'undefined' ? sliderElm.dataset.center_slides_bounds : false ;
    var loop = typeof sliderElm.dataset.loop !== 'undefined' ? sliderElm.dataset.loop : false ;
    var navigation = typeof sliderElm.dataset.navigation !== 'undefined' ? sliderElm.dataset.navigation : false ;

    return new Swiper('[data-id="'+sliderIdentifier+'"]', {
        modules: [Navigation, Autoplay],
        direction:'horizontal',
        slidesPerView:slides_xs,
        spaceBetween:15,
        centeredSlides:center_slides,
        centeredSlidesBounds:center_slides_bounds,
        loop: loop,
        autoplay: {
            delay: delay,
            disableOnInteraction: false,
        },
        navigation: {
            enabled: navigation,
            nextEl: '.swiper-button-next-slide-' + sliderIdentifier,
            prevEl: '.swiper-button-prev-slide-' + sliderIdentifier,
            disabledClass:'!bg-gray-700 text-gray-200'
        },
        breakpoints: {
            // // xs
            // 520: {
            //     slidesPerView:1.6,
            //     spaceBetween:15,
            // },
            // // sm
            // 640:{
            //     slidesPerView:2,
            //     spaceBetween:15,
            // },
            // md
            768: {
                slidesPerView:slides_md,
                spaceBetween:15,
            },
            // lg
            1024:{
                slidesPerView:slides_lg,
                spaceBetween:15,
            },
            // xl
            1280:{
                slidesPerView:slides_xl,
                spaceBetween:15,
            },
            // 2xl
            // 1536: {

            // },
        }
    });
}

const setupApp = ()=>
{
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const allSwipersCustom = document.querySelectorAll('.custom-swiper');
    allSwipersCustom.forEach(slider => buildSwiperCustom(slider));

    const mainSwiper = new Swiper('.main-swiper', {
        modules: [Navigation, Pagination, Autoplay, Keyboard],
        direction: 'horizontal',
        slidesPerView: 1,
        freeMode:true,
        clickable: "true",
        loop: true,
        autoplay: {
            delay: 2000,
            waitForTransition: false,
        },
        keyboard: true,
        speed: 1000,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'text-gray-400',
        },
    });

    const productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    const portfolioGalleryThumb = new Swiper('.portfolio-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 5.5,
        centeredSlides:true,
        centeredSlidesBounds:true,
        freeMode: true,
        loop: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            320: {
                slidesPerView: 3.5,
            },
            480: {
                slidesPerView: 3.5,
            },
            640: {
                slidesPerView: 4.5,
            }
        }
        // thumbs: {
        //   swiper: productGalleryThumb
        // }
    });

    const portfolioGallery = new Swiper('.portfolio-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // clickable:"true",
        spaceBetween: 10,

        thumbs: {
            swiper : portfolioGalleryThumb
        },
    });
}

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

window.addEventListener("livewire:navigated", function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
})

// console.clear();
